import { getToken, getStorage, getRefreshToken } from './localStorage';
export default { getToken, getStorage, getRefreshToken };
export { setObjectValueInStorage, getValueFromStorage } from './localStorage';
